import { assignModule } from '@blocks/base/store';
import user from '@blocks/user/module';

const state = {
  mid: 0,
};

const mutations = {
  setMID(state, str) {
    state.mid = str;
  },
  rainChance(state, bool) {
    state.userInfo.is_rain = bool;
  },
};

const actions = {
  // 事件
  authBefore({ dispatch }, to) {
    const {
      query: { mid },
    } = to;
    dispatch('setValue', { key: 'mid', mutation: 'setMID', value: mid });
  },
};

export default assignModule(user, {
  state,
  mutations,
  actions,
});
